import { Link } from 'react-router-dom';
import { EditorialImage } from './ui/EditorialImage';

const API_URL = import.meta.env.VITE_API_URL as string;

function resolveImageUrl(image: string | null | undefined): string | null {
  if (!image) return null;
  if (image.startsWith('http')) return image;
  return `${API_URL}${image}`;
}

export function CategoryCard({
  name,
  copy,
  seed,
  to,
  image,
  aspect = 'aspect-[4/5]',
}: {
  name: string;
  copy: string;
  seed: string;
  to: string;
  image?: string | null;
  aspect?: string;
}) {
  const imageUrl = resolveImageUrl(image);

  return (
    <Link to={to} className="group relative block overflow-hidden">
      {imageUrl ? (
        <div className={`${aspect} w-full overflow-hidden`}>
          <img
            src={imageUrl}
            alt={name}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
          />
        </div>
      ) : (
        <EditorialImage
          seed={seed}
          alt={name}
          duotone={false}
          aspect={aspect}
          className="transition-transform duration-500 group-hover:scale-[1.04]"
        />
      )}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/75 via-ink/5 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 flex flex-col items-start gap-3 p-5">
        <div>
          <h3 className="font-serif text-xl font-medium text-cream md:text-2xl">{name}</h3>
          <p className="mt-1 text-xs text-cream/75">{copy}</p>
        </div>
        <span className="shrink-0 border border-cream/70 px-3.5 py-2 text-[11px] font-medium uppercase tracking-[0.1em] text-cream transition-colors group-hover:bg-cream group-hover:text-ink">
          Shop
        </span>
      </div>
    </Link>
  );
}
